import { find } from 'lodash';

const endpoint = property => `/api/${property}/page-content`;

const pages = [
    {
        'slug': 'home',
        'name': 'Home page'
    },
    {
        'slug': 'treatments',
        'name': 'Treatments Listing Page'
    },
    {
        'slug': 'treatment',
        'name': 'Individual Treatment Page'
    },
    {
        'slug': 'spadays',
        'name': 'Spa Days Listing Page'
    },
    {
        'slug': 'spaday',
        'name': 'Individual Spa Day Page'
    },
    {
        'slug': 'checkoutdays',
        'name': 'Checkout - Spa Day Step'
    },
    {
        'slug': 'options',
        'name': 'Checkout - Options Step'
    },
    {
        'slug': 'suggestions',
        'name': 'Checkout - Suggestions Step'
    },
    {
        'slug': 'payment',
        'name': 'Checkout - Payment Step'
    },
    {
        'slug': 'review',
        'name': 'Checkout - Review Step'
    },
    {
        'slug': 'confirmation',
        'name': 'Confirmation Page'
    },
    {
        'slug': 'announcement',
        'name': 'Announcement Page'
    },
    {
        'slug': 'manage-booking',
        'name': 'Manage Booking Page'
    },
];

const adminPages = [
    {
        'slug': 'defaultspaday',
        'name': 'Individual Spa Day',
        'admin': true
    },
    {
        'slug': 'privacy',
        'name': 'Privacy Policy',
        'admin': true
    },
    {
        'slug': 'terms',
        'name': 'Terms',
        'admin': true
    },
    {
        'slug': 'defaultcheckoutdays',
        'name': 'Checkout - Spa Day Step',
        'admin': true
    },
    {
        'slug': 'defaultoptions',
        'name': 'Checkout - Options Step',
        'admin': true
    },
    {
        'slug': 'defaultsuggestions',
        'name': 'Checkout - Suggestions Step',
        'admin': true
    },
    {
        'slug': 'defaultpayment',
        'name': 'Checkout - Payment Step',
        'admin': true
    },
    {
        'slug': 'defaultreview',
        'name': 'Checkout - Review Step',
        'admin': true
    },
    {
        'slug': 'defaultconfirmation',
        'name': 'Confirmation Page',
        'admin': true
    },
];

const emailPages = [
    {
        'slug': 'bookingconfirm',
        'name': 'Confirmation Email'
    },
    {
        'slug': 'register',
        'name': 'Registration Email'
    },
    {
        'slug': 'booking',
        'name': 'Order Received Email'
    },
    {
        'slug': 'pendingpayment',
        'name': 'Pending Payment Email'
    }
];

export default ['api', 'pageContentTransformer', function (api, pageContentTransformer) {
    return {
        list: () => {
            return pages;
        },
        adminList: () => {
            return adminPages;
        },
        emailList: () => {
            return emailPages;
        },
        save: page => {
            return api.upload(`${endpoint(api.property())}/${page.page}`, page).then(response => response.data);
        },
        find: page => {
            return api.get(`${endpoint(api.property())}/${page}`)
                .then(response => pageContentTransformer.toJson(response.data));
        },
        findAdmin: page => {
            return api.get(`${endpoint(0)}/${page}`)
                .then(response => pageContentTransformer.toJson(response.data));
        },
        search: (type, text) => {
            return pages.filter(page => page.name.toLowerCase().includes(text.toLowerCase()));
        },
        pageDetails: slug => {
            return find(pages, { 'slug': slug }) || find(emailPages, { 'slug': slug });
        },
        globalPageDetails: slug => {
            return find(adminPages, { 'slug': slug });
        }
    };
}];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/pageContent/services/pageContent.service.js